import __request__ from "routing/request";
export function exportData(JSONbody, filename, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.views/views/search/pivot/export/${filename}`, JSONbody, {}, {
    "Accept": [
      "text/csv",
      "application/json",
      "application/yaml",
      "application/xml",
      "application/vnd.ms-excel"
    ]
  }, requestOptions);
}
